import { RefundTableCell } from '../table.common'

export const CellSku: RefundTableCell = (_, { productImage, product, option }) => (
	<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
		<div
			style={{
				backgroundColor: '#fcfcfc',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<img
				src={productImage}
				alt={product}
				style={{
					objectFit: 'contain',
					width: 60,
					height: 60,
				}}
			/>
		</div>

		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '12px' }}>
			<div style={{ textAlign: 'start', fontSize: '14px', lineHeight: '17px' }}>{product}</div>
			<div style={{ textAlign: 'start', fontSize: '14px', lineHeight: '17px', color: '#1677ff' }}>
				{option}
			</div>
		</div>
	</div>
)
